import { RootDispatch } from "redux/rootReducer";
import { empty, load, loadSuccess } from "./oidcActions";
import * as request from "utility/request";

const apiUrl = process.env.REACT_APP_API_URL;

export const postToken = (code: string, state: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.postAndReturnResponseJson(
        `${apiUrl}/api/oidc/token?code=${code}&state=${state}`
      );
      dispatch(loadSuccess(res));

      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export const removeState = empty;
